import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@zillow/constellation';
import { withPreload, Source, Picture as Picture$1 } from '@zillow/zrs-cms';
import { withAnchor } from '../../util/helpers.js';
import StructuredData from '../../components/StructuredData/StructuredData.js';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var SourcePreload = withPreload(Source);
var ImagePreload = withPreload(Image);
var BlockPicture = function BlockPicture(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var desktop = attrs.desktop,
    tablet = attrs.tablet,
    mobile = attrs.mobile,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    _attrs$decoding = attrs.decoding,
    decoding = _attrs$decoding === void 0 ? 'async' : _attrs$decoding;
  var structuredData = [desktop, tablet, mobile].filter(function (picture) {
    return Boolean(picture === null || picture === void 0 ? void 0 : picture.src);
  }).map(function (picture) {
    return {
      '@context': 'https://schema.org/',
      '@type': 'ImageObject',
      contentUrl: picture.src,
      caption: picture.alt,
      height: picture.height,
      width: picture.width
    };
  });
  var isPost = usePlacement() === 'post';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StructuredData, {
    data: structuredData
  }), /*#__PURE__*/React.createElement(Picture$1, _extends({
    key: index
  }, isPost && {
    marginBottom: 'md'
  }), mobile && /*#__PURE__*/React.createElement(SourcePreload, {
    srcSet: mobile.src,
    width: mobile.width,
    height: mobile.height,
    loading: loading,
    decoding: decoding,
    media: "sm_lte"
  }), tablet && /*#__PURE__*/React.createElement(SourcePreload, {
    srcSet: tablet.src,
    width: tablet.width,
    height: tablet.height,
    loading: loading,
    decoding: decoding,
    media: "md_lte"
  }), desktop && /*#__PURE__*/React.createElement(ImagePreload, {
    src: desktop.src,
    width: desktop.width,
    height: desktop.height,
    alt: desktop.alt,
    loading: loading,
    decoding: decoding
  })));
};
BlockPicture.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    desktop: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
      alt: PropTypes.string
    }),
    tablet: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    mobile: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    loading: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Picture = withAnchor(BlockPicture);

export { Picture as default };
